import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom'; // Import useParams
import { useHistory } from 'react-router-dom';
import { fetchData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';

const CompanyEdit = ({ match }) => {
    const recordId = match.params.id; // Assuming you're using React Router
    const history = useHistory();
    const [pinCodes, setPinCodes] = useState([]);

    const { isAuthenticated, companyId, permissions, isSuperAdmin, superCompanyId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const [formData, setFormData] = useState({
        Name: '',
        ContactNumber1: '',
        ContactNumber2: '',
        Email: '',
        AddressLine1: '',
        AddressLine2: '',
        GSTNumber: '',
        PanNumber: '',
        Location: '',
        PinCode: '',
        CashOpening: '',
        StockOpening: '',
        PaymentUPIId: '',
        PaymentUPIName: '',
        BToBPrefix: '',
        BToCPrefix: '',
        IGSTPrefix: '',
        FreightGSTRate: '',
        IsEinvoice: '',
        IsEwayBill: '',
        EinvoicePortalUserName: '',
        EinvoicePortalPassword: '',
        myGSTcafeCustomerID: '',
        myGSTcafeApiID: '',
        myGSTcafeApiSecret: '',
        IGSTCustomerPrefix: '',

    });


    const companyid = 1;
    useEffect(() => {
        fetchData('PinCodeApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    setPinCodes(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching PIN codes:', error);
            });
    }, []);



    useEffect(() => {
        fetchData('CompanyApi', `/CompanyDetails/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Company Details:', error);
            });
    }, []);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value === 'true' ? true : e.target.type === 'checkbox' ? e.target.checked : value,
        }));
    };


    const handleSubmit = event => {
        event.preventDefault();

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: 1,
        }));

        updateData('CompanyApi', `${companyId}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const phoneNumberPattern = /^\d{10}$/;
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;

    return (

        <div className="w-full max-w-sm container mt-2 mx-auto">
            <form onSubmit={handleSubmit}>
                <div className="w-full mb-2 flex" style={{ marginTop: '-10px' }}>
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Company</h6>
                    <Button
                        variant="contained"
                        style={{ marginLeft: '8px', backgroundColor: '#3d6d3dff', color: 'white', height: '26px' }}
                        onClick={handleSubmit}
                    >
                        <span style={{ fontSize: '13px' }}>Update</span>
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        component={Link}
                        to="/companyIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px', height: '26px' }}
                    >
                         <span style={{ fontSize: '13px' }}>Back To List</span>
                    </Button>
                </div>

                {/* Render fetched data */}
                <div className="w-full mb-2 flex">
                    <div className="w-full mr-2">
                        <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                            Company Name
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='Name' value={formData.Name} onChange={handleChange} type="text" placeholder=" Company name" style={{ fontSize: '12px' }}
                            required
                            maxLength={50}
                        />
                    </div>
                </div>

                <div className="w-full mb-2 flex">
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="contactNumber1">
                            Contact Number 1
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='ContactNumber1' value={formData.ContactNumber1} onChange={handleChange} type="text" placeholder=" Contact Number 1" style={{ fontSize: '12px' }}
                            required
                            maxLength={15}
                            pattern={phoneNumberPattern.source}
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="contactNumber2">
                            Contact Number 2
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='ContactNumber2' value={formData.ContactNumber2} onChange={handleChange} type="text" placeholder=" Contact Number 2" style={{ fontSize: '12px' }}
                            maxLength={15}
                            pattern={phoneNumberPattern.source}
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="email">
                            Email
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='Email' value={formData.Email} onChange={handleChange} type="text" placeholder=" Email" style={{ fontSize: '12px' }}
                            maxLength={30}
                            pattern={emailPattern.source}
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="gstNumber">
                            GST Number
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='GSTNumber' value={formData.GSTNumber} onChange={handleChange} type="text" maxLength={15} placeholder=" GST Number" style={{ fontSize: '12px' }} />
                    </div>

                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="gstNumber">
                            Pan Number
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='PanNumber' value={formData.PanNumber} onChange={handleChange} type="text" maxLength={15} placeholder=" Pan Number" style={{ fontSize: '12px' }} />
                    </div>
                </div>

                <div className="w-full mb-2 flex">
                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                            Address Line 1
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='AddressLine1' value={formData.AddressLine1} onChange={handleChange} type="text" placeholder=" Address Line 1" style={{ fontSize: '12px' }}
                            maxLength={200}
                            required
                        />
                    </div>

                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                            Address Line 2
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='AddressLine2' value={formData.AddressLine2} onChange={handleChange} type="text" placeholder=" Address Line 2" style={{ fontSize: '12px' }}
                            maxLength={200}
                        />
                    </div>

                </div>
                <div className="w-full mb-2 flex">

                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                            Location
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='Location' value={formData.Location} onChange={handleChange} type="text" placeholder=" Location" style={{ fontSize: '12px' }} />
                    </div>

                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                            PinCode
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='PinCode' value={formData.PinCode} onChange={handleChange} type="text" placeholder=" Pin Code" style={{ fontSize: '12px' }} />
                    </div>

                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                            Cash Opening
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='CashOpening' value={formData.CashOpening} onChange={handleChange} type="text" placeholder=" Cash Opening" style={{ textAlign: 'right', fontSize: '12px' }} />
                    </div>

                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                            Stock Opening
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='StockOpening' value={formData.StockOpening} onChange={handleChange} type="text" placeholder=" Stock Opening" style={{ textAlign: 'right', fontSize: '12px' }} />
                    </div>

                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                            Freight GST Rate
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            name='FreightGSTRate' value={formData.FreightGSTRate} onChange={handleChange} type="text" placeholder=" Freight GST Rate" style={{ textAlign: 'right', fontSize: '12px' }} />
                    </div>
                </div>

                <div className="w-full mb-2 flex">

                    {isSuperAdmin && (
                        <>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                                    Payment UPI Id
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='PaymentUPIId' value={formData.PaymentUPIId} onChange={handleChange} type="text" placeholder="Enter UPI Id" style={{ fontSize: '12px' }} />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                                    Payment UPI Name
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='PaymentUPIName' value={formData.PaymentUPIName} onChange={handleChange} type="text" placeholder="Enter UPI Name" style={{ fontSize: '12px' }} />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                                    B To B Prefix
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='BToBPrefix' value={formData.BToBPrefix} onChange={handleChange} type="text" placeholder="B To B Prefix" style={{ fontSize: '12px' }} />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                                    B To C Prefix
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='BToCPrefix' value={formData.BToCPrefix} onChange={handleChange} type="text" placeholder="B To C Prefix" style={{ fontSize: '12px' }} />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                                    IGST Prefix
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='IGSTPrefix' value={formData.IGSTPrefix} onChange={handleChange} type="text" placeholder="IGST Prefix" style={{ fontSize: '12px' }} />
                            </div>
                        </>
                    )}
                </div>

                <div className="w-full mb-2 flex">

                    {isSuperAdmin && (
                        <>
                            <div className="w-1/5 mr-2">
                                <label
                                    className="block uppercase tracking-wide text-xs mb-2 flex items-center gap-x-2 h-8"
                                    htmlFor="gstPercentage"
                                >
                                    E - Invoice
                                    <input
                                        type="checkbox"
                                        className="form-checkbox h-4 w-4 text-red-700"
                                        name="IsEinvoice"
                                        checked={formData.IsEinvoice || false}
                                        onChange={handleChange}
                                        style={{ marginLeft: '10px', fontSize: '12px' }}
                                    />

                                </label>
                            </div>

                            <div className="w-1/5 mr-2">
                                <label
                                    className="block uppercase tracking-wide text-xs mb-2 mb-2 flex items-center gap-x-2 h-8"
                                    htmlFor="gstPercentage"
                                >
                                    E - way Bill
                                    <input
                                        type="checkbox"
                                        className="form-checkbox h-4 w-4 text-red-700"
                                        name="IsEwayBill"
                                        checked={formData.IsEwayBill || false}
                                        onChange={handleChange}
                                        style={{ marginLeft: '10px', fontSize: '12px' }}
                                    />

                                </label>
                            </div>

                            <div className="w-1/3 mr-2">
                                <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                                    E-invoice Portal UserName
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='EinvoicePortalUserName' value={formData.EinvoicePortalUserName} onChange={handleChange} type="text" placeholder="E-invoice Portal UserName" style={{ fontSize: '12px' }} />
                            </div>

                            <div className="w-1/3 mr-2">
                                <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                                    E-invoice Portal Password
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='EinvoicePortalPassword' value={formData.EinvoicePortalPassword} onChange={handleChange} type="text" placeholder="E-invoic Portal Password" style={{ fontSize: '12px' }} />
                            </div>
                        </>
                    )}
                </div>

                <div className="w-full mb-2 flex">

                    {isSuperAdmin && (
                        <>

                            <div className="w-1/8 mr-2">
                                <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                                    GST cafe Customer ID
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='myGSTcafeCustomerID' value={formData.myGSTcafeCustomerID} onChange={handleChange} type="text" placeholder="GST cafe Customer ID" style={{ fontSize: '12px' }} />
                            </div>

                            <div className="w-1/8 mr-2">
                                <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                                    GST cafe Api ID
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='myGSTcafeApiID' value={formData.myGSTcafeApiID} onChange={handleChange} type="text" placeholder="GST cafe Api ID" style={{ fontSize: '12px' }} />
                            </div>

                            <div className="w-1/8 mr-2">
                                <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                                    GST cafe Api Secret
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='myGSTcafeApiSecret' value={formData.myGSTcafeApiSecret} onChange={handleChange} type="text" placeholder="GST cafe Api Secret" style={{ fontSize: '12px' }} />
                            </div>

                            <div className="w-1/8 mr-2">
                                <label className="block uppercase tracking-wide text-xs mb-2" htmlFor="name">
                                    IGST Customer Prefix
                                </label>
                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    name='IGSTCustomerPrefix' value={formData.IGSTCustomerPrefix} onChange={handleChange} type="text" placeholder="IGST Customer Prefix" style={{ fontSize: '12px' }} />
                            </div>

                        </>
                    )}
                </div>
            </form >
        </div >

    );
};

export default CompanyEdit;
